import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'painel', loadChildren: () => import('./views/painel/painel.routes').then(r => r.routes) },
  { path: '', loadChildren: () => import('./views/public/public.routes').then(r => r.routes) },
];
